import { render, staticRenderFns } from "./MedicineOneThird.vue?vue&type=template&id=53e5c4fa&"
import script from "./MedicineOneThird.vue?vue&type=script&lang=js&"
export * from "./MedicineOneThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
